import { Observable } from 'rxjs';

import { SelectNextByValueStep, StepNextType } from '../types';

// tslint:disable:unified-signatures
export class SelectNextByValueStepBuilder<Y> {
  private readonly valuetoNextStepMap: {
    matcher: (value: Y) => boolean;
    nextStep: StepNextType;
  }[] = [];

  public constructor(private readonly value: Observable<Y>) {}

  public addValueToStep(value: Y, nextStep: StepNextType): this;
  public addValueToStep(
    value: (value: Y) => boolean,
    nextStep: StepNextType,
  ): this;
  public addValueToStep(
    value: Y | ((value: Y) => boolean),
    nextStep: StepNextType,
  ): this;
  public addValueToStep(
    value: Y | ((value: Y) => boolean),
    nextStep: StepNextType,
  ): this {
    let matcher: (value: Y) => boolean;

    if (this.isFunction(value)) {
      matcher = value;
    } else {
      matcher = (v) => v === value;
    }

    this.valuetoNextStepMap.push({
      matcher,
      nextStep,
    });

    return this;
  }

  public addValuesToSteps(
    valuesToSteps: Parameters<
      SelectNextByValueStepBuilder<Y>['addValueToStep']
    >[],
  ): this {
    for (const valueToStep of valuesToSteps) {
      this.addValueToStep(...valueToStep);
    }
    return this;
  }

  public build(): SelectNextByValueStep<Y> {
    if (this.valuetoNextStepMap.length === 0) {
      throw new Error(`No next steps have been defined for step`);
    }

    return {
      stepType: 'SelectNextByValueStep',
      value: this.value,
      nextSelector: this.valuetoNextStepMap,
    };
  }

  private isFunction(value: unknown): value is (value: unknown) => boolean {
    return typeof value === 'function';
  }
}
